/**
 * v3 insurance form route names — used only by v3 providers.
 * Legacy flow keeps hardcoded insurance.* names and is not wired here.
 */
export const INSURANCE_V3_ROUTES = {
  applicant: 'insurance.v3.applicant',
  vehicles: 'insurance.v3.vehicles',
  drivers: 'insurance.v3.drivers',
  quote: 'insurance.v3.quote',
  quotePhone: 'insurance.quote.phone',
};

export function insuranceV3Route(step) {
  return INSURANCE_V3_ROUTES[step];
}
